import { useTranslation } from 'react-i18next';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/ApiError';
import { useNotifications } from '@/shared/ui/Notifications';

import { globalOnError } from './globalOnError';

export type UseAppMutationOptions<TData, TError, TVariables> =
  UseMutationOptions<TData, TError, TVariables>;

export function useAppMutation<
  TData = unknown,
  TError extends ApiError = ApiError,
  TVariables = void,
>(
  options: UseAppMutationOptions<TData, TError, TVariables> & {
    customError?: boolean;
  }
) {
  const { addNotification } = useNotifications();
  const { t } = useTranslation();

  let { onError } = options;

  if (!onError) {
    // Если нет кастомного обработчика и НЕ установлен customError
    if (!options.customError) {
      onError = (error: TError) => globalOnError(error, t, addNotification);
    }
    // Если customError=true но нет options.onError, то onError остается undefined
  }

  return useMutation<TData, TError, TVariables>({
    ...options,
    onError,
  });
}
